// 採寸データ削除時の「削除理由」入力ロジック (純関数)。
// プリセット選択と自由記述の両方に対応する。

// 削除理由のプリセット値
export const DELETE_REASON_PRESETS = ["顧客要望", "内部ミス削除", "データ不備", "その他"] as const;
export type DeleteReasonPreset = (typeof DELETE_REASON_PRESETS)[number];

// 「その他」を選んだ場合のみ自由記述を採用する
export const DELETE_REASON_OTHER: DeleteReasonPreset = "その他";

// 自由記述の最大文字数 (バックエンドの検証と揃える)
export const DELETE_REASON_MAX_LEN = 255;

/**
 * プリセット選択と自由記述から、リクエストに渡す削除理由文字列を解決する。
 * - プリセット未選択 → null
 * - 「その他」以外 → プリセット文字列
 * - 「その他」→ 自由記述を trim。空なら null
 * 理由は任意のため、いずれの場合も null を許容する。
 */
export function resolveDeleteReason(
  preset: DeleteReasonPreset | null,
  freeText: string
): string | null {
  if (!preset) {
    return null;
  }
  if (preset !== DELETE_REASON_OTHER) {
    return preset;
  }
  const trimmed = freeText.trim();
  return trimmed.length === 0 ? null : trimmed;
}
